import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';

export const getFilterValuesAsString = (filterConfig: FilterConfig, filterState: Filter) => filterConfig
    .map(([name]) => filterState[name])
    .filter((item) => !!item)
    .reduce((acc, curr) => [...acc, ...curr], [])
    .join(', ');
